// Centralized API configuration
// Base URL should NOT include /api - that will be added in individual endpoint calls
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Helper function to construct API endpoint URLs
export const getApiUrl = (endpoint) => {
  // Ensure endpoint starts with /api
  const normalizedEndpoint = endpoint.startsWith('/api')
    ? endpoint
    : `/api${endpoint.startsWith('/') ? '' : '/'}${endpoint}`;
  return `${API_BASE_URL}${normalizedEndpoint}`;
};

// Export default configuration
const apiConfig = {
  baseURL: API_BASE_URL,
  getApiUrl
};

export default apiConfig;
